module.exports = __webpack_public_path__ + "img/p29201.30f1fb8e.jpg";